import { getTenantConfig } from "~/config/tenant-config";

// Banner configuration
export const BANNER_END_DATE = new Date("2025-08-31T23:59:59.999Z");
export const BANNER_STORAGE_KEY = "feedback-banner-dismissed";

export const CUSTOMER_NAME = getTenantConfig().title;

export const TOUR_BANNER_STORAGE_KEY = "bill-analyzer-tour-banner-dismissed";
